import React from 'react';
import styled, { css } from 'styled-components';

import colors from '../../colors';

const Container = styled.div`
    background-color: ${colors.cardItemBackground};
    flex: ${({flex}) => flex || 1};
    justify-content: center;
    align-itens: center;
    position: relative;
    display: flex;
    flex-direction: column;
    ${props => props.borderBottom && css`
        border-bottom: 1px solid ${colors.border};
    `}
`;
const Value = styled.h2`
    color: ${({color}) => colors[color]};
    font-size: 48px;
    text-align: center;
    font-weight: 300;
    margin: 0;
    small {
        font-size: 22px;
    }
`;
const Label = styled.p`
    color: ${colors.label};
    font-size: 18px;
    text-align: center;
    margin: 0;
`;
const Progress = styled.div`
    background-color: ${({color}) => colors[color]};
    width: ${({percentage}) => percentage}%;
    height: 4px;
    left: 0;
    bottom: 0;
    position: absolute;
`;

const InfoWithProgressLine = ({
    color,
    percentage,
    value,
    label,
    borderBottom,
    flex
}) => (
    <Container borderBottom={borderBottom} flex={flex}>
        <Value color={color}>{value}<small>({percentage}%)</small></Value>
        <Label>{label}</Label>
        <Progress
            percentage={percentage}
            color={color}
        />
    </Container>
)

export default InfoWithProgressLine;
